import React, { useEffect, useState, useCallback } from 'react';
import { FaDollarSign, FaFireAlt, FaRegBookmark, FaRupeeSign } from 'react-icons/fa';
import { RiMoneyDollarCircleLine, RiMoneyRupeeCircleLine } from 'react-icons/ri';
import { Link } from 'react-router-dom';
import Breadcrumb from '../components/Breadcrumb';
import { getAllProduct } from '../API/ProductAPI';
import Config from '../API/Config';
import spinner from "../assets/images/tube-spinner.svg";

const Menu = () => {
  const [products, setProducts] = useState([]);
  const [displayedProducts, setDisplayedProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const productsPerPage = 8;

  const StateId = Config.getStateId();
  const CountryId = Config.getCountryId();
  const currencySymbol = CountryId === 'IN' ? <FaRupeeSign /> : <FaDollarSign />;

  // Flatten API response to get all products with category
  const flattenProducts = useCallback((data) => {
    return data.flatMap(category =>
      category.Products.map(product => ({
        ...product,
        category: category.Name
      }))
    );
  }, []);

  // Fetch products
  useEffect(() => {
    const fetchProduct = async () => {
      setLoading(true);
      try {
        const res = await getAllProduct(CountryId, StateId);
        // const flattenedProducts = flattenProducts(res);
        const flattenedProducts = res;
        setProducts(flattenedProducts);
        setDisplayedProducts(flattenedProducts.slice(0, productsPerPage));
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProduct();
  }, [StateId, CountryId, flattenProducts]);

  // Handle scroll event for infinite loading
  // useEffect(() => {
  //   const handleScroll = () => {
  //     if (
  //       window.innerHeight + document.documentElement.scrollTop >=
  //       document.documentElement.offsetHeight - 100 &&
  //       !loading &&
  //       displayedProducts.length < products.length
  //     ) {
  //       setLoading(true);
  //       setTimeout(() => {
  //         const nextPage = page + 1;
  //         const newProducts = products.slice(0, nextPage * productsPerPage);
  //         setDisplayedProducts(newProducts);
  //         setPage(nextPage);
  //         setLoading(false);
  //       }, 1000); // Simulate loading delay
  //     }
  //   };

  //   window.addEventListener('scroll', handleScroll);
  //   return () => window.removeEventListener('scroll', handleScroll);
  // }, [loading, page, products, displayedProducts.length]);

  // Handle View More button click
  const handleViewMore = () => {
    const nextPage = page + 1;
    const newProducts = products.slice(0, nextPage * productsPerPage);
    setDisplayedProducts(newProducts);
    setPage(nextPage);
  };

  return (
    <>
      <Breadcrumb title="Menu" path="Menu" />
      <div className="container mx-auto px-4 py-8 grid grid-cols-1 lg:grid-cols-4 gap-6">
         
        {/* Food Items Grid */}
        <div className="lg:col-span-4">
          {loading ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              {[...Array(8)].map((_, index) => (
                <div key={index} className="px-2">
                  <div className="bg-white shadow rounded-lg border border-[#e8e8e8] overflow-hidden animate-pulse">
                    <div className="w-full h-52 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded-lg mb-3"></div>
                    <div className="p-3">
                      <div className="h-4 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded mb-2"></div>
                      <div className="h-3 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded mb-2 w-3/4"></div>
                      <div className="h-3 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded mb-2 w-1/2"></div>
                      <div className="h-3 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded mb-3 w-2/3"></div>
                      <div className="h-8 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded-3xl"></div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              {displayedProducts.map((product, idx) => (
                <div key={product.Id} className="px-2 mb-3">
                  <Link to={`/product-view/${product.Id}`}>
                    <div className="bg-white shadow hover:shadow-[0px_8px_30px_rgba(0,0,0,0.15)] transform transition-transform duration-500 rounded-lg border border-[#e8e8e8] overflow-hidden">
                      <div className="relative overflow-hidden">
                        <img
                          src={product.ThumbImage}
                          alt={product.Name}
                          className="w-full h-52 object-cover rounded-lg mb-3 transform transition-transform duration-500 hover:scale-105"
                        />
                      </div>
                      <div className="p-3">
                        <h3 className="font-semibold text-lg text-gray-800">{product.Name}</h3>
                        <p className="text-contentcolor mb-1 text-sm">{product.category}</p>
                        <p className="text-contentcolor mb-1 flex items-center">
                          <FaFireAlt className="mr-1" /> {product.Calories} Calories
                        </p>
                        <p className="text-contentcolor mb-3 flex items-center">
                          <span className="mr-1 font-bold">
                            {currencySymbol}
                          </span>
                          <span className="font-semibold text-contentcolor">
                            {product.Variations[0]?.SalePrice || '15.00'}
                          </span>
                          {product.Variations[0]?.RegularPrice && (
                            <span className="line-through ml-1">
                              {product.Variations[0]?.RegularPrice}
                            </span>
                          )}
                          / {product.Variations[0]?.Name || 'piece'}
                        </p>
                        <button className="w-full bg-theme2 rounded-3xl text-white py-2 hover:bg-black transition-colors duration-300 font-medium">
                          Add To Cart
                        </button>
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          )}
          {!loading && loading && (
            <div className="flex justify-center my-8 col-span-full">
              <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-theme2"></div>
            </div>
          )}
          {displayedProducts.length < products.length && !loading && (
            <div className="flex justify-center mt-8 col-span-full">
              <button
                onClick={handleViewMore}
                className="bg-theme2 text-white px-8 py-3 rounded-3xl hover:bg-black transition-colors duration-300 font-medium shadow-md hover:shadow-lg"
              >
                Load More
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Menu;